import styled from 'styled-components';
import {fontSize, primaryGreenBtn} from '../../mixins';
import React/*, {useEffect, useState}*/ from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectToken, selectUserID} from '../auth/authSlice';
import {selectStripeNonce, sendUpsellPurchaseRequest} from './paywallSlice';
import {selectEventsData, selectFBPurchaseData} from '../onboarding/onboardingSlice';
import {EVENTS} from '../../analytics/events';
import {sendAnalyticsEvents} from '../../analytics/common';


const blackTxt = `
 ${fontSize(18)};
 line-height: 22px;
 letter-spacing: -0.41px;
 color: #323232;
 font-weight: 300;
`;

const checkIco = (
    <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M6.85049 12.0216C6.57485 12.0216 6.31119 11.9075 6.12244 11.7062L1.26575 6.52102C0.887242 6.11853 0.908215 5.48477 1.30969 5.10632C1.71217 4.72787 2.34435 4.74789 2.72086 5.15037L6.8405 9.54665L15.2376 0.333596C15.6111 -0.0758956 16.2423 -0.102928 16.6498 0.269519C17.0562 0.641965 17.0842 1.27573 16.7127 1.68321L7.58753 11.6952C7.40078 11.9015 7.13512 12.0196 6.85748 12.0216H6.85049Z" fill="#00BFA5"/>
    </svg>
);

const StyledPopup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 3px solid #FFD600;
  border-radius: 10px;
  position: relative;
  padding: 48px 0 8px;
  
  div, p, ul {
     width: 100%;
  }
  
   &::before {
    content: "Users’ Choice";
    position: absolute;
    top: -26px;
    right: 25px;
    width: auto;
    color: #323232;
    padding: 14px 16px;
    ${fontSize(13)};
    line-height: 18px;
    font-weight: 600;
    mix-blend-mode: normal;
    background-color: #FFD600;
    box-shadow: 0 2px 16px rgba(50, 50, 50, 0.1);
    border-radius: 24px;
    text-align: center;
  }
`;

const StyledRow = styled.div`
 display: flex;
 justify-content: space-between;
 padding: 0 18px;
 ${blackTxt};
`;

const StyledOff = styled.span`
  color: #00BFA5;
`;

const StyledLongLine = styled.p`
   width: 100%;
   margin: 0;
   padding: 12px 18px;
   border-bottom: 2px solid #F0F0F0;
   ${blackTxt};
   ${fontSize(14)};
   letter-spacing: -0.41px;
   color: #9C9C9C;
`;

const StyledList = styled.ul`
 list-style: none;
 padding: 0 18px;
 ${blackTxt};
 color: #9C9C9C;
 
 li {
   padding: 8px 0;
   
   svg {
     margin-right: 14px;
   }
 }
`;

const StyledGreyLine = styled.p`
  padding: 0 18px;
  ${blackTxt};
`;

const StyledButton = styled.button`
  ${primaryGreenBtn};
  background-color: #FBA253;
  width: 327px;
  border: none;
  margin-top: 16px;
`;

const UpsellPopup = ({onContinueCb,closePopup,upsellPlan}) => {
    const dispatch = useDispatch();
    const token = useSelector(selectToken);
    const stripeNonce = useSelector(selectStripeNonce);
    const amplitudeEventData = useSelector(selectEventsData);
    const fbPurchaseData = useSelector(selectFBPurchaseData);
    const userID = useSelector(selectUserID);

    const onContinueClick = () => {
        dispatch(sendUpsellPurchaseRequest(stripeNonce, upsellPlan, token, fbPurchaseData, amplitudeEventData, onContinueCb, userID));
        sendAnalyticsEvents(EVENTS.upsellTapped, amplitudeEventData);
        closePopup();
    };

    return (
        <StyledPopup>
            <StyledRow>
                <span>Special Offer</span>
                <StyledOff>50% off</StyledOff>
            </StyledRow>
            <StyledLongLine>Check your loved one’s drives.</StyledLongLine>

            <StyledGreyLine>$9.99/month</StyledGreyLine>

            <StyledList>
                <li>
                    {checkIco}
                    Get crash alerts
                </li>
                <li>
                    {checkIco}
                    Know where they go
                </li>
                <li>
                    {checkIco}
                    Check behavior on the road
                </li>
            </StyledList>
            <StyledButton onClick={onContinueClick} id='continue-button'>Confirm</StyledButton>
        </StyledPopup>
    );
};

export default UpsellPopup;